import { AgmCoreModule, GoogleMapsAPIWrapper } from "@agm/core";
import { CommonModule } from "@angular/common";
import { HTTP_INTERCEPTORS } from "@angular/common/http";
import { NgModule } from "@angular/core";
import { BreakPointRegistry, FlexFillStyleBuilder, FlexLayoutModule, FlexOrderStyleBuilder, FlexStyleBuilder, LayoutAlignStyleBuilder, LayoutStyleBuilder, MediaMarshaller, MediaObserver, PrintHook, ShowHideStyleBuilder, StylesheetMap, StyleUtils, ɵMatchMedia } from "@angular/flex-layout";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MAT_DATE_LOCALE } from "@angular/material/core";
import { NgxChartsModule } from "@swimlane/ngx-charts";
import { IConfig, NgxMaskModule } from "ngx-mask";
import { LoadingComponent } from "../components/loading/loading.component";
import { NettaScoreLabelComponent } from "../components/netta-score-label/netta-score-label.component";
import { NotificationModalComponent } from "../components/notification-modal/notification-modal.component";
import { SnakBarAlertComponent } from "../components/snak-bar-alert/snak-bar-alert.component";
import { UploadFileSimpleComponent } from "../components/upload-file-simple/upload-file-simple.component";
import { Constant } from "../constant";
import { AppIfOnDomDirective } from "../directives/app-if-on-dom.directive";
import { AppMatSidenavHelperDirective, AppMatSidenavTogglerDirective } from "../directives/app-mat-sidenav-helper.directive";
import { AppPerfectScrollbarDirective } from "../directives/app-perfect-scrollbar.directive";
import { AppPipeModule } from "../pipes/pipes.modules";
import { AppMatSidenavHelperService } from "../services/app-mat-sidenav-helper.service";
import { AppMatchMediaService } from "../services/app-match-media.service";
import { ConektaService } from "../services/conekta.service";
import { InterceptorService } from "../services/interceptor.service";
import { NavbarService } from "../services/navbar.service";
import { RappiService } from "../services/rappi.service";
import { MaterialModule } from "./material.module";
import { CookieService } from 'ngx-cookie-service';
import { WsNotificationsService } from "../services/websockets/ws-notifications.service";
import { WeetrustService } from "../services/weetrust.service";
import { SignedContractComponent } from "../components/signed-contract/signed-contract.component";
import { CompleteInfoPropertyComponent } from "../components/complete-info-property/complete-info-property.component";
import { CompleteInquilinoInfoComponent } from "../components/complete-inquilino-info/complete-inquilino-info.component";
import { GooglePlaceModule } from "ngx-google-places-autocomplete";
import { StripeService } from "../services/stripe.service";
import { AdvancePayComponent } from "../components/advance-pay/advance-pay.component";

const maskConfigFunction: () => Partial<IConfig> = () => {
    return {
      validation: false,
    };
};

@NgModule({
    declarations: [
        AppMatSidenavHelperDirective,
        AppMatSidenavTogglerDirective,
        AppIfOnDomDirective,
        AppPerfectScrollbarDirective,
        NotificationModalComponent,
        SnakBarAlertComponent,
        LoadingComponent,
        NettaScoreLabelComponent,
        UploadFileSimpleComponent,
        SignedContractComponent,
        CompleteInfoPropertyComponent,
        CompleteInquilinoInfoComponent,
        AdvancePayComponent
    ],
    imports: [
        FlexLayoutModule,
        MaterialModule,
        CommonModule,
        FormsModule,
        AppPipeModule,
        ReactiveFormsModule,
        AgmCoreModule.forRoot({apiKey: 'AIzaSyBxyqx1ovc98MV7imdwemTz421H_VsCBrM', libraries: ['places', 'geometry']}),
        GooglePlaceModule,
        NgxChartsModule,
        NgxMaskModule.forRoot(maskConfigFunction)
    ],
    exports: [
        FlexLayoutModule,
        MaterialModule,
        CommonModule,
        FormsModule,
        AppMatSidenavHelperDirective,
        AppMatSidenavTogglerDirective,
        AppPipeModule,
        AppPerfectScrollbarDirective,
        ReactiveFormsModule,
        AppIfOnDomDirective,
        AgmCoreModule,
        NgxChartsModule,
        NgxMaskModule,
        LoadingComponent,
        NettaScoreLabelComponent,
        UploadFileSimpleComponent,
        GooglePlaceModule,
        AdvancePayComponent
    ],
    entryComponents: [
        SnakBarAlertComponent
    ],
    providers: [
        AppMatchMediaService,
        NavbarService,
        AppMatSidenavHelperService,
        Constant,
        StyleUtils,
        StylesheetMap,
        MediaMarshaller,
        ɵMatchMedia,
        BreakPointRegistry,
        PrintHook,
        LayoutStyleBuilder,
        FlexStyleBuilder,
        ShowHideStyleBuilder,
        FlexOrderStyleBuilder,
        MediaObserver,
        LayoutAlignStyleBuilder,
        FlexFillStyleBuilder,
        GoogleMapsAPIWrapper,
        {
            provide: HTTP_INTERCEPTORS,
            useClass: InterceptorService,
            multi: true
        },
        {
            provide: MAT_DATE_LOCALE,
            useValue: 'es-MX'
        },
        ConektaService,
        RappiService,
        CookieService,
        WsNotificationsService,
        WeetrustService,
        StripeService,
    ]
})
export class SharedModule {}
